import { ActivatedRoute, Router } from '@angular/router';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** UUID válido en query `?uuid=` (enlaces desde registro de actividad). */
export function parseActivityDeepLinkUuid(route: ActivatedRoute): string | null {
	const raw = route.snapshot.queryParamMap.get('uuid');
	return raw && UUID_RE.test(raw.trim()) ? raw.trim() : null;
}

/** Quita `uuid` de la URL sin recargar la página. */
export function clearActivityUuidQueryParam(router: Router, route: ActivatedRoute): void {
	void router.navigate([], {
		relativeTo: route,
		queryParams: { uuid: null },
		queryParamsHandling: 'merge',
		replaceUrl: true,
	});
}
